import { useState } from 'react';
import { Row, Col, Card, Container } from 'react-bootstrap';
import { ControlButtons } from '../ControlButtons';

// TODO: This component was very coupled to the form stepper, and unfortunately still is
// semi-coupled to the form stepper in many ways, even though it needs to be re-used.
// The method currently in place to allow reuse with the formComponent prop is not ideal
// and was implemented just to get reuse somewhat working. The form stepper navigation
// really should be pulled out into its own HOC or something so that this only has to worry
// about being a reusable control.

export const BurnType = ({
	currBurntype = '',
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	compact = false,
	formComponent = false,
	onChange = () => {},
	onBlur = () => {},
}) => {
	const [selectedBurnType, setSelectedBurnType] = useState(currBurntype);

	const setSelection = val => {
		setSelectedBurnType(val);
		if (formComponent) onChange(val);
	};

	return (
		<Container className={!compact ? 'component mt-5' : 'mt-5'}>
			<h2 className="mb-4">
				{!compact ? 'What Permit Are You Applying For?' : 'Burn Type'}
			</h2>
			{!compact && (
				<>
					<p>
						This permit application is to allow for burning in horticultural or
						agricultural operations, which include burning the following:
					</p>
					<ul id="acceptable-burn-list">
						<li>Clippings from trees, bushes, and plants.</li>
						<li>Dead/diseased trees.</li>
						<li>
							Weed growth along ditch banks, incident to clearing ditches for
							irrigation purposes.
						</li>
					</ul>
					<div
						style={{
							background: '#b72c0a',
							color: 'white',
							textAlign: 'center',
							borderRadius: '5%',
						}}>
						<em>
							*Burning trash, coated wire, plastic products, tires, building
							products, etc. IS NOT allowed.*
						</em>
					</div>
				</>
			)}
			<Row className="mt-4 d-flex flex-row mb-4">
				<Col className=" mb-3" xs="12" md="6">
					<Card
						className="d-flex"
						onClick={() => setSelection('agricultural')}
						onBlur={onBlur}
						style={
							selectedBurnType === 'agricultural'
								? { border: 'solid #0074d9 2px' }
								: {}
						}>
						<Card.Body className="burn-type-card-body">
							<Card.Title>Agricultural Burn Permit</Card.Title>
							<Card.Subtitle className="text-muted">
								<hr />
								<p>
									<strong>For properties with 5 or more acres.</strong>
								</p>
								<p>2 calendar years.</p>
							</Card.Subtitle>
						</Card.Body>
					</Card>
				</Col>
				<Col className="mb-3" xs="12" md="6">
					<Card
						className="d-flex"
						onClick={() => setSelection('open')}
						onBlur={onBlur}
						style={
							selectedBurnType === 'open' ? { border: 'solid #0074d9 2px' } : {}
						}>
						<Card.Body className="burn-type-card-body">
							<Card.Title>Open Burn Permit</Card.Title>
							<Card.Subtitle className="text-muted">
								<hr />
								<p>
									<strong>For properties less than 5 acres.</strong>
								</p>
								<p>1 calendar year.</p>
								<p>
									<em>
										No open burning allowed from June 1st - September 15th.
									</em>
								</p>
							</Card.Subtitle>
						</Card.Body>
					</Card>
				</Col>
			</Row>
			{!formComponent && (
				<ControlButtons
					onSubmit={burnType => onSubmit(burnType)}
					onNext={() => onNext(selectedBurnType)}
					onPrev={onPrevious}
					finalStep={finalStep}
					disableNext={selectedBurnType === '' ? true : false}
					disablePrev={disablePrev}></ControlButtons>
			)}
		</Container>
	);
};
